<script lang="ts">
    import type { SVGAttributes } from "svelte/elements";

    interface $$Props extends SVGAttributes<SVGSVGElement>{
        r?: number
        strokeWidth?: number
    }

    export let r: $$Props["r"] = 60
    export let strokeWidth: $$Props["strokeWidth"] = 1

</script>

<svg {...$$restProps} viewBox="0 0 120 120">
    <circle
        stroke="currentColor"
        stroke-width={strokeWidth}
        fill="white"
        r={r  - strokeWidth}
        cx=50%
        cy=50%
    />
</svg>